import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

export type Database = {
  public: {
    Tables: {
      user_profiles: {
        Row: {
          id: string;
          email: string;
          full_name: string;
          avatar_url: string | null;
          is_active: boolean;
          created_at: string;
          updated_at: string;
        };
      };
      transactions: {
        Row: Transaction;
        Insert: Omit<Transaction, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Transaction, 'id' | 'created_at'>>;
      };
      uploaded_documents: {
        Row: UploadedDocument;
        Insert: Omit<UploadedDocument, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<UploadedDocument, 'id' | 'created_at'>>;
      };
      budgets: {
        Row: Budget;
        Insert: Omit<Budget, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Budget, 'id' | 'created_at'>>;
      };
    };
  };
};

export interface Transaction {
  id: string;
  user_id: string;
  document_id?: string | null;
  date: string;
  merchant: string;
  description?: string | null;
  amount: number;
  category: string;
  transaction_type: 'Income' | 'Expense';
  source: 'Personal' | 'Business';
  business_name?: string | null;
  recurring: boolean;
  tax_deductible: boolean;
  status: 'Verified' | 'Pending' | 'Flagged' | 'Review';
  notes?: string | null;
  ai_confidence?: number;
  created_at?: string;
  updated_at?: string;
}

export interface UploadedDocument {
  id: string;
  user_id: string;
  file_name: string;
  file_size?: number | null;
  file_type?: string | null;
  document_category: string;
  storage_path?: string | null;
  status: 'pending' | 'processing' | 'complete' | 'error';
  extracted_count: number;
  error_message?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface Budget {
  id: string;
  user_id: string;
  budget_type: string;
  business_name?: string | null;
  category: string;
  budget_amount: number;
  period: string;
  created_at?: string;
  updated_at?: string;
}
